import React from 'react';
import { Link } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import { useI18n } from '../i18n/index.jsx';

export default function NotFound() {
  const { t } = useI18n();
  return (
    <DashboardLayout>
      <div className="flex-1 overflow-auto">
        <div className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-rose-500/25 blur-3xl hidden md:block" />
        <div className="pointer-events-none absolute bottom-[-90px] right-[-90px] h-96 w-96 rounded-full bg-amber-500/20 blur-3xl hidden md:block" />

        <div className="relative z-10 py-16 px-5 sm:px-6">
          <div className="mx-auto max-w-3xl text-center">
            <div className="inline-flex items-center justify-center h-14 w-14 rounded-2xl bg-white/5 border border-white/10 text-slate-300">
              <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeWidth="1.6" d="M10 9h4M9 13h6M7 17h10" />
              </svg>
            </div>
            <h1 className="mt-4 text-3xl font-bold text-white">{t('notfound.title')}</h1>
            <p className="mt-2 text-slate-400">{t('notfound.text')}</p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
              <Link to="/dashboard" className="rounded-xl bg-emerald-500 px-4 py-2 text-sm font-medium text-slate-950 hover:bg-emerald-400">{t('notfound.dashboard')}</Link>
              <Link to="/souvenirs" className="rounded-xl bg-white/5 border border-white/10 px-4 py-2 text-sm text-slate-200 hover:bg-white/10">{t('notfound.memories')}</Link>
              <Link to="/libraries" className="rounded-xl bg-white/5 border border-white/10 px-4 py-2 text-sm text-slate-200 hover:bg-white/10">{t('notfound.libraries')}</Link>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
